import { Navigate, useSearchParams } from 'react-router';
import { signInUrl } from '../api.js';
import { Loading } from '../components/Notice.js';
import { useMe } from '../hooks.js';

export function SignInPage() {
  const [params] = useSearchParams();
  const error = params.get('error');
  const rawNext = params.get('next') ?? '/';
  const next = rawNext.startsWith('/') && !rawNext.startsWith('//') ? rawNext : '/';
  const me = useMe();

  if (me.loading) return <Loading />;
  if (me.data) return <Navigate to={next} replace />;

  return (
    <div className="card centered">
      <h1>Xero Builder Platform</h1>
      <p className="subtle">
        Put the apps you build online for the people in your practice, behind Sign in with Xero.
      </p>
      {error ? (
        <div className="notice notice-error" role="alert">
          {error}
        </div>
      ) : null}
      <p>
        <a className="btn btn-xero" href={signInUrl(next)}>
          Sign in with Xero
        </a>
      </p>
      <p className="small subtle">
        You sign in with the Xero account you already use. We only see your name and email.
      </p>
    </div>
  );
}
